module.exports = __webpack_public_path__ + "img/ew-icon_contests.d1330346.svg";